<template>
	<div>
		<headTop :data="'yes'"></headTop>
		<div class="wid-1200">
			<div class="page-tit">
				<span>
					<router-link :to="{path:'/index'}" class="to-home">首页</router-link>
				</span>
				<span> > </span>
				<span class="page-name">{{name}}</span>
			</div>
			<div class="clearfix" v-if="this.nav[0]">
				<el-col :span="span" class="menu-box fl">
					<el-menu
							:default-active="this.nav[0].id.toString()"
							class="el-menu-vertical-demo"
							@open="handleOpen"
							@close="handleClose"
							background-color="rgba(255, 247, 239, 0.6)"
							text-color="#D83E26"
							active-text-color="#ffffff">
						<el-menu-item
								:index="(item.id).toString()"
								v-for="item in nav"
								:key="item.uid"
								:class="{ active: item.uid === active }"
								:title="item.columnName"
								@click="menuTabsFunc(item)">
							<span slot="title" >{{ item.columnName }}</span>
						</el-menu-item>
					</el-menu>
				</el-col>
				<div class="page-content fl">
					<div class="title" :title="title" :width="titleWid">
						<img src="../assets/images/graph-arrow.png" alt="">
						<span>{{title ? title : ""}}</span>
					</div>
					<div class="content-box" :width="contentWid">
						<el-tabs v-model="activeName" @tab-click="handleClick">
							<el-tab-pane
									v-for="item in tabs"
									:label="item.columnName"
									:name="item.columnName"
									:uid="item.uid"
									:key="item.uid">
								<div v-loading="listLoading">
									<div v-if="!listData || listData.length === 0 " class="empty-box">
										<img src="../assets/images/empty.jpg" alt=''>
										<span>暂无数据</span>
									</div>
									<div v-if="content" class="tab-content" v-html="content" >
									</div>
									<div v-else  class="tab-content-box">
										<ul class="tab-list-box" >
											<li v-for="cur in listData" :key="cur.id">
												<a :href="cur.nodeUrl" target="_blank">
													<span class="list-title" :title="cur.title">{{cur.title}}</span>
													<span v-if="item.columnName === '专家解读' " class="list-source" :title="cur.author.replace(/;$/gi,'')">{{cur.author.replace(/;$/gi,'')}}</span>
													<span v-else class="list-source" :title="cur.source">{{cur.source}}</span>
													<span class="list-date">{{cur.pubDate.trim().split(" ")[0]}}</span>
												</a>
											</li>
										</ul>
										<el-pagination
											background
											layout="prev, pager, next"
											:total="total"
											:current-page="currentPage"
											@current-change="handleCurrentChange"
										>
										</el-pagination>
									</div>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>
<script>

	export default {
		name: 'aspect',
		props:{
			active: {
				type: Number,
				default: 1
			},
			name: {
				type: String,
				default: '十个明确'
			},
			type: {
				type: String,
				default: 'aspect'
			},
			span:{
				type: Number,
				default: 5
			},
			titleWid:{
				type: String,
				default:'860px'
			},
			contentWid:{
				type: String,
				default:'800px'
			}
		},
		components: {

		},
		data() {
			return {
				activeName: '理论研究',
				title:'',
				nav: [],
				tabs:[],
				content:'',
				listData:[],
				total:0,
				currentPage: 1, //分页默认显示第一页
				listId:'',
				listLoading:false,
				djUrl:this.url.djUrl
			};
		},
		created() {
			console.log('type===',this.type);
			/* //获取到localStorage里的值
            this.username = localStorage.getItem("username");
            this.userData.groupid = localStorage.getItem("groupid");
            this.userData.userid = localStorage.getItem("userid");
            this.groupid_list = JSON.parse(
                window.localStorage.getItem("groupid_list")
            ); */

			//yes网站版 no镜像版
			//web:网页版 mirror:镜像版
			if(this.isWeb=='yes'){
				this.v_type="web";
			}else{
				this.v_type="mirror";
			}

		},
		mounted() {
			this.initDataFunc();
		},
		methods: {
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			async handleCurrentChange(currentPage) {
				//点击第几页
				this.currentPage = currentPage;
				const res = await this.listChange(this.listId);
				if(res.data.code === 200) {
					this.listLoading = false;
					this.content = res.data?.rows[0]?.buildContent
					this.source = res.data?.rows[0]?.buildSource
					this.listData = res.data?.rows
					this.total = res.data?.total
				}
			},
			// 初次加载的时候调用
			async initDataFunc(){
				this.listLoading = true;
				const res = await this.navChange();
				if(res.data.code === 200) {
					this.nav = res.data.rows;
					this.title = res.data.rows[0].columnName;
					if(!res?.data?.rows[0]?.uid) {
						return false;
					}
					const res1 = await this.tabChange(res.data.rows[0].uid);
					if(res1.data.code === 200) {
						this.tabs = res1.data.rows;
						if(!res1?.data?.rows[0]?.uid) {
							return false;
						}
						this.listId = res1.data.rows[0].uid
						const res2 = await this.listChange(this.listId);
						if(res2.data.code === 200) {
							this.listLoading = false;
							this.content = res2.data?.rows[0]?.buildContent
							this.listData = res2.data?.rows
							this.total = res2.data?.total
						}else {
							console.log("获取失败！");
						}
					} else {
						console.log("获取失败！");
					}
				} else {
					console.log("获取失败！");
				}
			},
			// 左侧menu
			async menuTabsFunc(item){
				this.listLoading = true;
				const res1 = await this.tabChange(item.uid);
				this.title = item.columnName;
				if(res1.data.code === 200) {
					this.tabs = res1.data.rows;
					this.activeName = res1.data.rows[0].columnName
					this.listId = res1.data.rows[0].uid
					const res2 = await this.listChange(this.listId);
					if(res2.data.code === 200) {
						this.listLoading = false;
						this.content = res2.data?.rows[0]?.buildContent
						this.listData = res2.data?.rows
						this.total = res2.data?.total
					}else {
						console.log("获取失败！");
					}
				} else {
					console.log("获取失败！");
				}
			},
			// 点击tabs
			// async tabsFunc(item){
			// 	this.listLoading = true;
			// 	const res2 = await this.listChange(item.uid);
			// 	if(res2.data.code === 200) {
			// 		this.listLoading = false;
			// 		this.content = res2.data.rows[0]?.buildContent || ''
			// 		this.listData = res2.data.rows || ''
			// 	}else {
			// 		console.log("获取失败！");
			// 	}
			// },

			navChange() {
				const params = {
					"uid":"caa0756a-cb91-44ed-8f56-92fde066a20d",
					"pageSize":10,
					"pageNum":1,
					"sign":"更多"
				};
				return new Promise((resolve, reject) => {
					this.axios({
						method:'post',
						url:this.djUrl + "data/list/",
						data: params
					})
					.then((res) => {
						resolve(res);
					}).catch(error => {
						reject(error)
					});
				});
			},

			tabChange(id) {
				const params = {
					"uid":id,
					"pageSize":10,
					"pageNum":1,
					"sign":"更多"
				};
				return new Promise((resolve, reject) => {
					this.axios({
						method:'post',
						url:this.djUrl + "data/list/",
						data: params
					})
					.then((res) => {
						resolve(res);
					}).catch(error => {
						reject(error)
					});
				});
			},

			async handleClick(tab) {
				this.listLoading = true;
				this.listId = tab.$attrs.uid;
				this.currentPage = 1;
				const res = await this.listChange(this.listId);
				if(res.data.code === 200) {
					this.listLoading = false;
					this.content = res.data?.rows[0]?.buildContent
					this.listData = res.data?.rows
					this.total = res.data?.total
				}
			},

			listChange(id) {
				this.listLoading = true;
				const params = {
					"uid":id,
					"pageSize":10,
					"pageNum":this.currentPage ? this.currentPage : 1,
					"sign":"更多"
				};
				return new Promise((resolve, reject) => {
					this.axios({
						method:'post',
						url: this.djUrl + "data/list/",
						data: params
					})
					.then((res) => {
						resolve(res);
						this.listLoading = false;
					}).catch(error => {
						reject(error)
					});
				});
			},
		},
		computed: {},
	};
</script>

<style lang="scss" scoped>
	.page-tit{
		margin:25px 0;
		color:#3D3D3D;
		font-size: 16px;
		.page-name{
			color:#C42215;
		}
		.to-home:hover{
			color:#900;
		}
	}
	.menu-box{
		border-bottom: 6px solid #FBEFE3;
		margin-right: 45px;
		margin-bottom: 30px;
		.el-menu{
			border:none;
			counter-reset:item 0;
			height: 700px;
			overflow-y: scroll;
			overflow-x: hidden;
			.el-menu-item{
				text-align: left;
				font-size: 16px;
				min-height: 117px;
				padding: 10px 20px;
				color:#666666 !important;
				line-height: 24px;
				white-space: break-spaces;
				height:fit-content;
				padding-bottom: 10px;
				height: auto;
				word-break: break-all;
				white-space: normal;
				width: 240px;
				min-height: 120px;
				overflow: hidden;
				&.active,&:hover{
					color:#666666 !important;
					background: #FCEAE3 !important;
				}
				span{
					counter-increment: item;
				}
				span::before{
					content:counter(item);
					background: #F07A6E;
					width: 20px;
					height: 20px;
					text-align: center;
					line-height: 20px;
					border-radius: 5px;
					display: inline-block;
					color:#ffffff;
					margin-right: 5px;
				}
			}
			.el-menu-item.is-active{
				background:#FCEAE3 !important;
			}
		}
	}
	.page-content{
		width: 860px;
		.title{
			height: 40px;
			line-height: 40px;
			font-size: 18px;
			color:#ffffff;
			display: flex;
			align-items: center;
			padding-left: 40px;
			border-radius: 15px 1px 15px 1px;
			background: linear-gradient(90deg, #EB6047 0%, #CD3A2B 100%);
			margin-bottom: 20px;
			white-space: nowrap;
			overflow: hidden;
			padding-right: 10px;
			img{
				margin-right: 8px;
			}
			span{
				width: 99%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
		.content-box /deep/{
			border-radius: 10px;
			padding:20px 40px;
			margin-bottom: 200px;
			min-height: 400px;
			box-shadow: 0px 0px 10px 0px rgba(193, 193, 193, 0.2);
			.el-tabs__header{
				font-size: 16px;
				.el-tabs__nav-wrap::after{
					height: 1px;
					background-color: #C42215;
				}
				.el-tabs__nav .el-tabs__item{
					font-size: 16px !important;
					&.active,&:hover{
						color:#C42215 !important;
					}
				}
				.el-tabs__nav .el-tabs__item.is-active{
					color: #C42215 !important;
				}
				.el-tabs__nav .el-tabs__active-bar{
					height: 5px !important;
					border-radius: 10px 10px 0px 0px !important;
					background: #C42215 !important;
				}
			}
			.el-tabs__content {
				.tab-content{
					font-size: 15px;
					line-height: 2.5;
					white-space: pre-line;
					color:#666666;
					padding: 0 20px 0 0;
					-moz-user-select: none;
					-webkit-user-select: none;
					-ms-user-select: none;
					-khtml-user-select: none;
					-o-user-select: none;
					user-select: none;
				}
				.tab-list-box li{
					height:50px;
					line-height: 50px;
					border-bottom: 1px dashed #E5E5E5;
					a{
						display: flex;
						width: 100%;
						span{
							color:#666666;
							font-size: 15px;
						}
						.list-title{
							width: 60%;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							margin-right: 10px;
							&:hover{
								color:#ea5f47;
							}
						}
						.list-source{
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							width:25%;
							text-align: left;
						}
						.list-date{
							width: 15%;
							text-align: right;
						}
					}

				}

			}

			.tab-content-box {
				.el-pagination {
					text-align: center;
					margin-top: 45px;
				}
				.el-pagination.is-background .el-pager li:not(.disabled):hover {
					color: #ed6d46;
				}
			}
		}
	}

</style>
